import urlParse from 'url-parse';

const setURLParam = (param, value) => {
  const url = urlParse(global.window.location.href, true);
  const query = url.query;
  const newQuery = Object.assign({}, query, { [param]: value });
  url.set('query', newQuery);
  if (global.window.history.replaceState) {
    global.window.history.replaceState({}, null, url.href);
    return true;
  }
  return false;
};

export default setURLParam;



// WEBPACK FOOTER //
// ./src/controllers/Session/setURLParam.js